import moment from 'moment';

moment.updateLocale('en', {
  relativeTime: {
    future: (value: string) => (value.toLocaleLowerCase() === 'now' ? 'soon' : `in ${value}`),
    past: (value: string) => (value.toLocaleLowerCase() === 'now' ? value : `${value} ago`),
    s: 'Now',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
  },
});

export function getDateTitle(date: Date | number): string {
  return moment(date).calendar(undefined, {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd',
    lastDay: '[Yesterday]',
    lastWeek: '[Last] dddd',
    sameElse: 'LL',
  });
}

export function getDate(date: Date | number): string {
  return moment(date).fromNow();
}
